/**
 * superadminMsaGateBypassService -- the SuperAdmin read/write surface for a
 * distributor's MSA launch gate bypass (F2, Jake 2026-10-21).
 *
 * Backs `api/src/endpoints/superadmin_distributors.py`:
 *
 *   GET /api/superadmin/distributors/:id/msa-gate-bypass
 *   PUT /api/superadmin/distributors/:id/msa-gate-bypass
 *
 * Both are SA-only (`superadmin.settings`, not impersonating); every other
 * caller gets the same 404. The columns are excluded from the generic
 * distributor resource, so this is the only read.
 *
 * Response: { id, bypassed, bypassed_at, reason, bypassed_by: {id, name} | null,
 *             msa_confirmed }
 */
import axios from "@/axios";

function bypassUrl(distributorId) {
    return `/api/superadmin/distributors/${distributorId}/msa-gate-bypass`;
}

export function getMsaGateBypass(distributorId) {
    return axios.get(bypassUrl(distributorId));
}

/**
 * Turn the bypass on (`bypassed` true) or off. `reason` is required both
 * ways (1-500 characters); the server writes an audit row per change and
 * answers with the new record. A 400 carries `{ message }`.
 */
export function setMsaGateBypass(distributorId, bypassed, reason) {
    return axios.put(bypassUrl(distributorId), { bypassed, reason });
}
